import { useState } from 'react'

/** State for the Text Styles section's Heading Large preview card. */
export function useTextStylesPreview() {
  const [headingLarge, setHeadingLarge] = useState(true)
  const [headingFontFamily] = useState('Comic Sans')
  const [headingFontWeight] = useState('Regular')
  const [selectedText, setSelectedText] = useState<string | null>(null)

  return {
    headingLarge,
    setHeadingLarge,
    headingFontFamily,
    headingFontWeight,
    selectedText,
    setSelectedText,
  }
}

export type TextStylesPreview = ReturnType<typeof useTextStylesPreview>
